import type { WidgetProps } from '@rjsf/utils';

import { CodeEditor } from '@/components/monaco/codeEditor/codeEditor';
import { KeyValue } from '@/components/ui/keyValue/keyValue';

type Props = {
  options?: {
    language?: string;
    height?: React.CSSProperties['height'];
  };
} & Pick<WidgetProps, 'name' | 'value' | 'label'>;

export const CodeEditorReaderWidget = ({
  value = '',
  label = 'Code',
  options = {
    language: 'json',
    height: '300px'
  },
  name
}: Props) => {
  const language = options.language || 'json';
  const height = options.height || '300px';

  if (label === 'Answer') {
    return (
      <CodeEditor height={height} language={language} readOnly value={value} />
    );
  }

  return (
    <KeyValue dataCyName={name} title={label}>
      <div className="w-full">
        <CodeEditor
          height={height}
          language={language}
          readOnly
          value={value}
        />
      </div>
    </KeyValue>
  );
};
